
import axios from 'axios';
 
const http = axios.create({
  baseURL: '/api',
  timeout: 1000,
  // 请求拦截
  requestInterceptors: config => {
    // 可以在这里添加token或其他请求头
    // config.headers['Authorization'] = 'Bearer your-token';
    return config;
  },
  // 响应拦截
  responseInterceptors: response => {
    // 可以在这里对响应数据做处理
    return response.data;
  },
  // 错误拦截
  errorInterceptors: error => {
    // 处理请求错误
    return Promise.reject(error);
  }
});
 
export default http;